import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_BEGIN,
  MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_FAILURE,
  MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchCustomerGroupData(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "descend",
          sortedBy: "modifiedTimestamp",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getCustomerGroup`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          
          dispatch({
            type: MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchCustomerGroupDataError() {
  return {
    type: MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_DISMISS_ERROR,
  };
}

export function useFetchCustomerGroupData() {
  const dispatch = useDispatch();

  const { customerGroupData,fetchCustomerGroupDataPending, fetchCustomerGroupDataError } = useSelector(
    state => ({
      customerGroupData: state.manageSubs.customerGroupData,
      fetchCustomerGroupDataPending: state.manageSubs.fetchCustomerGroupDataPending,
      fetchCustomerGroupDataError: state.manageSubs.fetchCustomerGroupDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchCustomerGroupData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchCustomerGroupDataError());
  }, [dispatch]);

  return {
    customerGroupData,
    fetchCustomerGroupData: boundAction,
    fetchCustomerGroupDataPending,
    fetchCustomerGroupDataError,
    dismissFetchCustomerGroupDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchCustomerGroupDataPending: true,
        fetchCustomerGroupDataError: null,
      };

    case MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        customerGroupData: action.data,
        fetchCustomerGroupDataPending: false,
        fetchCustomerGroupDataError: null,
      };

    case MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchCustomerGroupDataPending: false,
        fetchCustomerGroupDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_CUSTOMER_GROUP_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchCustomerGroupDataError: null,
      };

    default:
      return state;
  }
}
